import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { JobFlowWorkStep } from '@data-terminal/shared-models/job-flow';
import { HdmuiKeyValueVerticalComponent } from '@heidelberg/hdmui-angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'data-terminal-job-flow-node',
    imports: [HdmuiKeyValueVerticalComponent, MatCardModule, MatProgressBarModule, TranslateModule],
    templateUrl: './job-flow-node.component.html',
    styleUrl: './job-flow-node.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobFlowNodeComponent {
    public readonly workStep = input.required<JobFlowWorkStep>();
    public readonly selected = input(false);

    public readonly machineNames = input<Map<string, string>>(new Map());

    public readonly machineDisplayName = computed(() => {
        const plannedMachine = this.workStep().plannedMachine;
        return plannedMachine ? (this.machineNames().get(plannedMachine) ?? plannedMachine) : plannedMachine;
    });

    public readonly deviceClassTranslationKey = computed(() => {
        const deviceClass = this.workStep().deviceClass?.toUpperCase() ?? '';
        const suffix = deviceClass.startsWith('ID_') ? deviceClass : `ID_${deviceClass}`;
        return `DC.MACHINE_CLASS.${suffix}`;
    });

    public readonly progress = computed(() => {
        const { cumulativeQuantity, targetQuantity } = this.workStep();
        return targetQuantity > 0 ? Math.min((cumulativeQuantity * 100) / targetQuantity, 100) : 0;
    });
}
